import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FaseEstrategicaModel, ResponseFaseEstrategicaModel, SubdimensionModel } from 'src/app/model/FaseEstrategica.model';
import { ResponseUnidadEducativaModel, UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { PlanMejoraService } from 'src/app/service/planMejora.service';
import Swal from 'sweetalert2';
import { JardinPlanMejoraComponent } from '../../jardin-plan-mejora.component';

@Component({
  selector: 'app-fase-estrategica',
  templateUrl: './fase-estrategica.component.html',
  styleUrls: ['./fase-estrategica.component.css']
})
export class FaseEstrategicaComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  @Input() simulacion: boolean;
  cargando: boolean;
  cambios: boolean;
  dataJardin = new JardinModel();
  faseEstrategicaData = new FaseEstrategicaModel();
  uniEducativa = new UnidadEducativaModel(); 
  click = false;


  constructor(
    @Inject(JardinPlanMejoraComponent) private parent: JardinPlanMejoraComponent,
    private api: apiService,
    private planMejoraService: PlanMejoraService
    ) {}

  ngOnInit(): void {     
    this.click = false;
    this.cargando = true;
    this.cambios = false;
    this.cargaInicial();
  }

  change() {
    this.cambios = true;
  }
  
  cargaInicial(){
    this.dataJardin = this.api.dataJardin;
    this.unidadEducativa(this.dataJardin);
    this.getFaseEstrategica(this.dataJardin);

  }

  formatObjetivos(objetivos:string){
    objetivos = objetivos.replace(/\.\s/g, '.<br>');
    return objetivos;

  }

  getPeriodoJardin(periodo){
    let periodoString = "2021"
    if(periodo == "Alternativo"){
      periodoString = "2024-2027"
    }else{
      periodoString = "2024-2027"
    }
    return periodoString
  }

  unidadEducativa(dataJardin:JardinModel){
      this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
        this.uniEducativa = response.payload;  
      },
      (err) => {
        console.log(err)
      });      
  }

  getFaseEstrategica(dataJardin:JardinModel){
    this.planMejoraService.API_POST_getFaseEstrategica(dataJardin.id).subscribe((response:ResponseFaseEstrategicaModel) => {
      this.faseEstrategicaData = response.payload;  
      this.cargando = false;
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      console.log(err)
    });      
  }

  guardarFaseEstrategica(){
    if (this.click == false) {
      this.click = true;
      this.planMejoraService.API_POST_guardarFaseEstrategica(this.dataJardin.id,this.faseEstrategicaData).subscribe((response:any) => {
        this.cambios = false;
        this.ngOnInit();
        Swal.fire({
          title: 'Realizado!',
          text: 'Guardado con éxito',
          icon: 'info',
          confirmButtonText: 'OK'
        })
      },
      (err) => {
        console.log(err)
      });   
    }

  }

  validarFinalizar(){
    let errores = [];
    Swal.fire({
      title: 'Este proceso no se puede deshacer, ¿Desea continuar?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.faseEstrategicaData.areas.forEach(area => {
          area.subdimensiones.forEach(subdimension => {
            if (this.validarSubdimension(subdimension, area.orden) != "") {
              errores.push(this.validarSubdimension(subdimension, area.orden))
            }
          });
        });
        if (errores.length > 0) {
          Swal.fire({
            title: 'Faltan campos',
            text: errores[0],
            icon: 'error',
            confirmButtonText: 'OK'
          })
        } else {
          this.finalizarFaseEstrategica();
        }
      }
    })
  }

  validarSubdimension(subdimension : SubdimensionModel, areaOrden : number) : string{
    let error = ""
    if (this.campoVacio(subdimension.objetivosAreas[0].objetivoTexto) || 
            (this.campoVacio(subdimension.objetivosAreas[0].meta) || 
            this.campoVacio(subdimension.objetivosAreas[0].estrategia1) || 
            this.campoVacio(subdimension.objetivosAreas[0].estrategia2)) 
        ){
      error = "Faltan elementos de completar en la Dimensión " + areaOrden + ", subdimensión " + subdimension.subdimension;
    }
    return error;
  }

  campoVacio(campo : string) : boolean {
      return ( campo == null || campo == "") ? true : false;
  }

  finalizarFaseEstrategica(){
    this.planMejoraService.API_POST_guardarFaseEstrategica(this.dataJardin.id,this.faseEstrategicaData).subscribe((response:any) => {
      this.planMejoraService.API_POST_finalizarFaseEstrategica(this.dataJardin.id).subscribe((response:any) => {
        this.irAFinalizar();
      },
      (err) => {
        console.log(err)
      });  
    },
    (err) => {
      console.log(err)
    });      
  }

  irA(){
    this.parent.ngOnInit();
    this.parent.componente="";
  }

  irAFinalizar(){
    Swal.fire({
      title: 'Fase estratégica finalizada con éxito',
      icon: 'success',
      confirmButtonText: 'OK'
    }).then(() => {
      //this.parent.menuVisible("planmejora");
      this.irA();
    })
  }

  volver(){
    if (this.cambios == true){
      Swal.fire({
        title: 'Tiene cambios sin guardar, ¿desea continuar?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.irA();
        } 
      })
    }else {
      this.irA();
    } 
  }

}
